import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { BannerComponent, BannerContentComponent } from './styles'
import { Navigation } from 'swiper'
import { SwiperButton } from '../SwiperSlideButtons'
import EmbedVideoIframe from '../Utils/EmbedVideoIframe'

const BannerContent = (banner, ratio) => {
  if (banner.desktop_banner_type == 'video') {
    const clickHandler = banner.link
      ? () => {
          window.open(banner.link, banner.new_page ? '_blank' : '_self')
        }
      : () => {}

    return (
      <div className="banner__iframe-container" onClick={clickHandler}>
        <EmbedVideoIframe url={banner.desktop_video} autoplay={true} />
        <div
          className="banner__iframe-overlay"
          style={{ cursor: banner.link ? 'pointer' : '' }}
        ></div>
      </div>
    )
  }

  return (
    <>
      {banner.link ? (
        <a href={banner.link} target={banner.new_page ? '_blank' : '_self'}>
          <BannerContentComponent
            bannerDesktopURL={banner.desktop?.banner_webp.url}
            bannerMobileURL={banner.mobile?.banner_webp.url}
            ratio={ratio}
          />
        </a>
      ) : (
        <BannerContentComponent
          bannerDesktopURL={banner.desktop?.banner_webp.url}
          bannerMobileURL={banner.mobile?.banner_webp.url}
          ratio={ratio}
        />
      )}
    </>
  )
}

const Banner = ({ items, ratio }) => {
  if (!items.length) return null
  return (
    <BannerComponent>
      {items.length > 1 && (
        <SwiperButton id="banner-prev-button">
          <ArrowLeft strokeWidth={2} />
        </SwiperButton>
      )}

      <Swiper
        centerInsufficientSlides={true}
        className="swiper-container"
        grabCursor={true}
        loop={items.length > 1}
        modules={[Navigation]}
        navigation={{
          nextEl: '#banner-next-button',
          prevEl: '#banner-prev-button',
        }}
        preventClicks={true}
        speed={200}
      >
        {items.map((item, index) => {
          return (
            <SwiperSlide className="swiper-slide-container" key={index}>
              {BannerContent(item, ratio)}
            </SwiperSlide>
          )
        })}
      </Swiper>

      {items.length > 1 && (
        <SwiperButton id="banner-next-button">
          <ArrowRight strokeWidth={2} />
        </SwiperButton>
      )}
    </BannerComponent>
  )
}

Banner.defaultProps = {
  items: [],
  className: '',
  ratio: 2.67,
}

Banner.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  ratio: PropTypes.number,
}

export default Banner
